import "./meniji.css";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../api";

const Meniji = ({ data }) => {
	const seznam_menijev = [
		"OSNOVNI TOPLI MENI 1",
		"OSNOVNI TOPLI MENI 2",
		"RASTLINSKI MENI",
		"FAST MENI",
		"SOLATNI MENI",
		"OSNOVNI HLADNI MENI",
		"TREND MENI",
		"VEGETARIJANSKI MENI",
		"SLADKI MENI",
		"BREZ »SVINJINE« MENI",
	];

	const initialCheckboxValues = {
		blacklist:
			data.menu_data.blacklist ||
			new Array(seznam_menijev.length).fill(false),
		whitelist:
			data.menu_data.whitelist ||
			new Array(seznam_menijev.length).fill(false),
	};

	const [checkboxValues, setCheckboxValues] = useState(initialCheckboxValues);

	const handleChange = (type, index) => {
		setCheckboxValues((prevValues) => {
			const newValues = { ...prevValues };
			newValues[type] = prevValues[type].map((value, i) =>
				i === index ? !value : value
			);
			return newValues;
		});
	};

	useEffect(() => {
		fetch(
			`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
				data.sessionToken
			)}&menu_data=${encodeURIComponent(
				checkboxValues.blacklist
			)}&type=blacklist`
		)
			.then((response) => response.json())
			.catch((error) => {
				console.log(error);
			});
	}, [checkboxValues.blacklist, data.sessionToken]);

	useEffect(() => {
		fetch(
			`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
				data.sessionToken
			)}&menu_data=${encodeURIComponent(
				checkboxValues.whitelist
			)}&type=whitelist`
		)
			.then((response) => response.json())
			.catch((error) => {
				console.log(error.message);
			});
	}, [checkboxValues.whitelist, data.sessionToken]);

	return (
		<div>
			<div className="meniji">
				<h2>Nastavitve menijev</h2>
				<p>
					Označi katerih menijev nočeš za malico in katere želiš. Če
					menija ne označiš bo ostal nevtralen.
				</p>
				<div className="stolpca">
					<ul>
						<h2>Nezaželjeni</h2>
						{seznam_menijev.map((ime_menija, index) => (
							<li key={ime_menija}>
                <label>{ime_menija}</label>
								<input
									type="checkbox"
									checked={checkboxValues.blacklist[index]}
									onChange={() =>
										handleChange("blacklist", index)
									}
								/>
							</li>
						))}
					</ul>
					<ul>
						<h2>Zaželjeni</h2>
						{seznam_menijev.map((ime_menija, index) => (
							<li key={ime_menija}>
                <label>{ime_menija}</label>
								<input
									type="checkbox"
									checked={checkboxValues.whitelist[index]}
									onChange={() =>
										handleChange("whitelist", index)
									}
								/>
							</li>
						))}
					</ul>
				</div>
				<button
					onClick={() => {
						window.location.reload();
					}}
					className="save-btn btn">
					Shrani
				</button>
			</div>
		</div>
	);
};

export default Meniji;
